"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarouselSection = void 0;
var solid_1 = require("@heroicons/react/24/solid");
var react_1 = __importStar(require("react"));
require("../../../index.css");
var CarouselSection = /** @class */ (function (_super) {
    __extends(CarouselSection, _super);
    function CarouselSection() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.intervalId = null;
        _this.handleNextSlide = function () {
            var currentSlideIndex = (_this.props.currentSlide + 1) % _this.props.slides.length;
            _this.props.handleSetCurrentSlide(currentSlideIndex);
        };
        _this.handlePrevSlide = function () {
            var currentSlideIndex = _this.props.currentSlide === 0
                ? _this.props.slides.length - 1
                : _this.props.currentSlide - 1;
            _this.props.handleSetCurrentSlide(currentSlideIndex);
        };
        _this.handleIndicator = function (index) {
            _this.props.handleSetCurrentSlide(index);
        };
        return _this;
    }
    CarouselSection.prototype.componentDidMount = function () {
        this.intervalId = setInterval(this.handleNextSlide, 5000);
    };
    CarouselSection.prototype.componentWillUnmount = function () {
        if (this.intervalId)
            clearInterval(this.intervalId);
    };
    CarouselSection.prototype.render = function () {
        var _this = this;
        var carouselSize = {
            width: this.props.carouselWidth,
            height: this.props.carouselHeight,
        };
        var carouselClassName = "relative " + this.props.className;
        var overlayOpacity = "brightness(50%)";
        switch (this.props.carouselOverlay) {
            case "high":
                overlayOpacity = "brightness(25%)";
                break;
            case "medium":
                overlayOpacity = "brightness(50%)";
                break;
            case "low":
                overlayOpacity = "brightness(75%)";
                break;
            default:
                break;
        }
        return (react_1.default.createElement("div", { className: carouselClassName, style: carouselSize },
            react_1.default.createElement("div", { className: "absolute bottom-0 left-0 right-0 z-30 mx-[15%] mb-4 flex list-none justify-center p-0" }, this.props.slides.map(function (_, index) { return (react_1.default.createElement("button", { key: index, type: "button", onClick: function () { return _this.handleIndicator(index); }, className: "mx-[3px] box-content h-[3px] w-[30px] flex-initial cursor-pointer border-0 border-y-[10px] border-solid border-transparent bg-white bg-clip-padding p-0 -indent-[999px] opacity-50 transition-opacity duration-[600ms] ease-[cubic-bezier(0.25,0.1,0.25,1.0)] motion-reduce:transition-none ".concat(index === _this.props.currentSlide ? "opacity-100" : ""), "aria-current": index === _this.props.currentSlide ? "true" : "false", "aria-label": "Slide ".concat(index + 1) })); })),
            react_1.default.createElement("div", { className: "relative w-full overflow-hidden after:clear-both after:block after:content-['']" }, this.props.slides.map(function (slide, index) {
                var _a;
                return (react_1.default.createElement("a", { href: slide === null || slide === void 0 ? void 0 : slide.link, target: "_blank", rel: "noreferrer" },
                    react_1.default.createElement("div", { key: index, className: "".concat(index === _this.props.currentSlide ? "block" : "hidden", " relative float-left -mr-[100%] w-full transition-transform duration-[600ms] ease-in-out motion-reduce:transition-none"), style: { backfaceVisibility: "hidden" } },
                        _this.props.customComponent && (react_1.default.createElement("div", { className: "absolute top-0 left-0 flex items-center justify-center z-10  w-full h-full" }, _this.props.customComponent)),
                        react_1.default.createElement("img", { src: slide.image, className: "block w-full object-cover ".concat((_a = _this.props.imageClassName) !== null && _a !== void 0 ? _a : ""), alt: "Slide ".concat(index), style: __assign(__assign({}, carouselSize), { filter: (slide === null || slide === void 0 ? void 0 : slide.title) || (slide === null || slide === void 0 ? void 0 : slide.description)
                                    ? overlayOpacity
                                    : "none" }) }),
                        react_1.default.createElement("div", { className: "absolute inset-x-[15%] bottom-5 py-5 text-center text-white" },
                            react_1.default.createElement("h5", { className: "text-xl" }, slide === null || slide === void 0 ? void 0 : slide.title),
                            react_1.default.createElement("p", null, slide === null || slide === void 0 ? void 0 : slide.description)))));
            })),
            react_1.default.createElement("button", { className: "absolute bottom-0 left-0 top-0 z-30 flex w-[15%] items-center justify-center border-0 bg-none p-0 text-center text-white opacity-50 transition-opacity duration-150 ease-[cubic-bezier(0.25,0.1,0.25,1.0)] hover:text-white hover:no-underline hover:opacity-90 hover:outline-none focus:text-white focus:no-underline focus:opacity-90 focus:outline-none motion-reduce:transition-none", type: "button", onClick: this.handlePrevSlide },
                react_1.default.createElement(solid_1.ChevronLeftIcon, { className: "w-8 h-8" })),
            react_1.default.createElement("button", { className: "absolute bottom-0 right-0 top-0 z-30 flex w-[15%] items-center justify-center border-0 bg-none p-0 text-center text-white opacity-50 transition-opacity duration-150 ease-[cubic-bezier(0.25,0.1,0.25,1.0)] hover:text-white hover:no-underline hover:opacity-90 hover:outline-none focus:text-white focus:no-underline focus:opacity-90 focus:outline-none motion-reduce:transition-none", type: "button", onClick: this.handleNextSlide },
                react_1.default.createElement(solid_1.ChevronRightIcon, { className: "w-8 h-8" }))));
    };
    return CarouselSection;
}(react_1.Component));
exports.CarouselSection = CarouselSection;
//# sourceMappingURL=index.js.map